import React from 'react'
import { SignUpCreatePasswordForm } from '@/features'
import { BaseView, StickyHeaderNavigation } from '@/components'
import { useTranslation } from 'react-i18next'

export const SignUpCreatePasswordScreen: React.FC = () => {
  const { t } = useTranslation()
  return (
    <BaseView flex={1} gap={25} px={12} className="h-full">
      <StickyHeaderNavigation />
      <p className="text-2xl font-bold text-left">
        {t('translation:signup.passwordCreate')}
      </p>
      <div className="h-full justify-between flex flex-col">
        <SignUpCreatePasswordForm />
      </div>
    </BaseView>
  )
}
